import consumer from './consumer';
import { publishCartCount } from '../stores/cart_count';

consumer.subscriptions.create('CartChannel', {
  received(data) {
    publishCartCount(data.cart_items_count);
    const update = () => {
      const elements = document.querySelectorAll('.cart-items-count');

      elements.forEach((el) => (el.innerText = data.cart_items_count));
    };

    update();

    const observer = new MutationObserver(() => {
      if (document.querySelector('.cart-items-count')) {
        update();
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  },
});
